import { toast } from "react-toastify";

/**
 * Show toast notification
 *
 * @param {string} message - Message to display
 * @param {"success" | "error" | "warning" | "info" | "danger"} type
 */
export const showToast = (message, type = "info") => {
  const options = {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
  };

  switch (type) {
    case "success":
      toast.success(message, options);
      break;

    case "error":
    case "danger": // alias for backend error mapping
      toast.error(message, options);
      break;

    case "warning":
      toast.warn(message, options);
      break;

    case "info":
    default:
      toast.info(message, options);
      break;
  }
};
